export default __webpack_public_path__ + "static/media/circle2.ed4ba17b.svg";